/* eslint-disable @typescript-eslint/no-explicit-any */
import { ModuleBase } from './ModuleBase'
import { hall } from '@/hall'
import { base } from '@/base/base'
import { WebDefine } from '@/defines/WebDefine'
import { log } from '@/utils/functions'
import { PopupViews } from '@/defines/EnumDefine'

export class VipEquityModule extends ModuleBase {
  public RETRY_COUNT = 3
  public vipEquityInfos: Record<string, any> = {}
  public vipEquityList: Record<string, any> = {}
  public vipEquityRecvReward = 0
  public limitation = 10 //限制领取最低金币
  getedVipEquityList: boolean = false

  init(): void {
    this.vipEquityInfos = {}
    this.vipEquityList = {}
    this.vipEquityRecvReward = 0
    this.getedVipEquityList = false
  }

  onClear(): void {
    this.vipEquityInfos = {}
    this.vipEquityList = {}
    this.vipEquityRecvReward = 0
    this.getedVipEquityList = false
  }

  onLoad(): void {}

  onDestroy(): void {}

  inits2c(): void {}

  onPreloadData(): void {
    log('VipEquityModule onPreloadData')
    this.requestVipEquity()
    this.requestVipEquityRewardList()
  }

  //获取vip权益config配置
  requestVipEquity(): void {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
    }
    base.httpUtil
      .postJson(WebDefine.userVipEquityConfig, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          this.vipEquityInfos = respJson.data
          hall.userModule.vipLevel = respJson.data.level
          hall.eventDispatcher.emit(hall.EventDefine.VipEquityConfig)
        }
      })
      .catch((error) => {
        log('error:requestVipEquity', error)
      })
  }

  //获取vip权益奖励列表
  requestVipEquityRewardList(): void {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
    }
    base.httpUtil
      .postJson(WebDefine.userVipEquityRewardList, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          this.vipEquityList = respJson.data
          this.getedVipEquityList = true

          hall.eventDispatcher.emit(hall.EventDefine.VipEquityList)
          // hall.eventDispatcher.emit(hall.EventDefine.TryAddPopupView, hall.Constants.VipEquityList);
          hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed) //刷新钻石转化/vip权益
        }
      })
      .catch((error) => {
        log('error:requestVipEquityRewardList', error)
      })
  }

  //请求领取Vip权益奖励 -- 1:等级 2:周 3:半月 4:月 5:负盈利反水 6:bonus转化
  tryGetVipEquityRecvReward_(type: number): void {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
      type: type,
    }
    base.httpUtil
      .postJson(WebDefine.userVipEquityRecvReward, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          this.vipEquityRecvReward = respJson.data.reward
          hall.eventDispatcher.emit(hall.EventDefine.VipEquityRecvReward)
          hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed) //刷新钻石转化/vip权益
          this.requestVipEquityRewardList()
        }
      })
      .catch((error) => {
        log('error:tryGetVipEquityRecvReward_', error)
      })
  }

  getVipEquityInfos() {
    if (this.vipEquityInfos) {
      const keys = Object.keys(this.vipEquityInfos).length
      if (keys > 0) {
        return this.vipEquityInfos
      }
    }
    return false
  }

  getVipEquityList() {
    if (this.vipEquityList) {
      const keys = Object.keys(this.vipEquityList).length
      if (keys > 0) {
        return this.vipEquityList
      }
    }
    return false
  }

  getVipEquityRecvReward() {
    return this.vipEquityRecvReward
  }

  // 是否已获取到弹窗判断的数据
  isGetedPopupData() {
    return this.getedVipEquityList
  }

  // 是否需要弹窗
  popupView() {
    // 钻石转化弹框——每日一次，当可领取金币数≥10的时候弹出
    if (typeof this.vipEquityList == 'object') {
      if ('bonus' in this.vipEquityList) {
        const bonus = Number(this.vipEquityList['bonus'])
        if (!isNaN(bonus) && bonus >= 10) {
          hall.popupViewModule.addPopupView(PopupViews.VipConversionPanel)
        }
      }
    }
  }

  //获取vip钻石转换红点
  getVipDiamondRed() {
    return this.vipEquityList['bonus'] >= this.limitation
  }

  //获取vip权益红点
  getVipEquityRed() {
    if ((this.vipEquityList as any) != false && Object.keys(this.vipEquityList).length > 0) {
      const levelInfo = this.vipEquityList['level']
      const weekInfo = this.vipEquityList['week']
      const halfMonthInfo = this.vipEquityList['half_month']
      const MonthInfo = this.vipEquityList['month']
      const cashBackInfo = this.vipEquityList['loss']
      if (levelInfo && weekInfo && halfMonthInfo && MonthInfo && cashBackInfo) {
        if (
          levelInfo != 0 ||
          weekInfo != 0 ||
          halfMonthInfo != 0 ||
          MonthInfo != 0 ||
          cashBackInfo >= this.limitation
        ) {
          return true
        }
      }
      return false
    } else {
      return false
    }
  }
}
